import { createStyles } from "@mantine/core";
import { colors, pxToRem } from "theme";

export const useStyles = createStyles(() => ({
  samplePhoto: {
    maxHeight: "100%",
    maxWidth: "100%",
  },
  samplePhotoContainer: {
    width: "25%",
    maxHeight: "90px",
    display: "flex",
    justifyContent: "center",
    borderRight: `1px solid ${colors.grey[40]}`,

    "&:last-child": {
      borderRight: "none",
    },
  },
  samplePhotosRow: {
    width: "100%",
  },
  explanationButton: {
    alignSelf: "flex-start",
  },
  description: {
    fontSize: pxToRem[16],
  },
}));
